import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class StocksDetailsService {

    constructor(private _http: HttpClient) { }

    getdetails(data) {
        return this._http.post(environment.api_url + 'seller/product/stocklisting', data);
    }

}
